<div #diagramDiv class="diagramDiv" [style.height]="height()"></div>
